import React, { Component } from 'react';
import './App.css';
import Cache from './cmp/Cache.js';
import Network from './cmp/Network.js';
import Manifest from './cmp/Manifest.js';
import DataViewer from './cmp/DataViewer.js';
import NavTabs from './cmp/NavTabs.js';


class App extends Component {
 
  constructor(props) 
  {
    super(props)

    this.state = {
      application:  props.application,
      cache:        props.application.getCache(),
      network:      props.application.getNetwork(),
      cacheIsShown: false,
      networkIsShown: false,
      viewerIsShown: false,
      showData: false,
     
    }
    this.updateApp = this.updateApp.bind(this);
    this.dataTogglePopup = this.dataTogglePopup.bind(this);
   
  }
  dataTogglePopup = () => {  
    this.setState({  
       showData: !this.state.showData 
        }); 
          } 

    updateApp(){this.forceUpdate()};

     handleShowCache = () => {
       this.setState({cacheIsShown: !this.state.cacheIsShown})
      }; 

     handleShowNetwork = () => {
       this.setState({networkIsShown: !this.state.networkIsShown})
      }; 

     handleShowViewer = () => {
       this.setState({viewerIsShown: !this.state.viewerIsShown})
      };

     handleHomePage = () => {
       this.setState({cacheIsShown: false, networkIsShown: false, viewerIsShown: false})
      }; 

     handleClearAll = () => {
       this.state.application.setNewManifest(null);
       this.state.cache.clear();
       this.updateApp();
      };
      

  render()
  
  {
      
    
    return (
      <div className="container">
      <div className="App col-lg-12 bg-secondary rounded mb-0 text-white">
        <NavTabs 
        handleShowCache={this.handleShowCache} handleShowNetwork={this.handleShowNetwork} handleShowViewer={this.handleShowViewer} 
        handleHomePage={this.handleHomePage} handleClearAll={this.handleClearAll} cacheIsShown={this.state.cacheIsShown} 
        networkIsShown={this.state.networkIsShown} viewerIsShown={this.state.viewerIsShown} application={this.state.application}
        />
          <br/>
       <div>
        <Manifest application={ this.state.application }  updateApp={this.updateApp} showData={this.state.showData} dataTogglePopup={this.dataTogglePopup.bind(this)}
        manifest={this.state.application.getCurrentManifest()} rootManifest={true}/> 
        </div>
        <br/>
        <div>{this.state.cacheIsShown ?
        <Cache application={this.state.application} showData={this.state.showData} dataTogglePopup={this.dataTogglePopup.bind(this)} cache={this.state.cache} updateApp={this.updateApp}/> : null}
        </div>
        <br/>
        <div>{this.state.networkIsShown ?
        <Network network={this.state.network} updateApp={this.updateApp}/> : null}
        </div>
        <br/>
        <div>
        <DataViewer application={this.state.application}  handleShowViewer={this.handleShowViewer.bind(this)} dataTogglePopup={this.dataTogglePopup.bind(this)} showData={this.state.showData} viewerIsShown={this.state.viewerIsShown}/> 
      </div>
         </div>
         </div>
    );
  }
}

export default App;

